// extracted by mini-css-extract-plugin
export default {"container":"EmailRecipientSelect_container__v2h7N"};